module.exports = __webpack_public_path__ + "img/full0-min.6610ba93.png";